import { defineStore } from 'pinia'
import rentsourceApi from '@/api/rentsource'
import type { CancelablePromiseWrapper } from '@/utils'
import type {
  MarketComparablePayload,
  MarketFilters,
  MarketStatsQuery,
  PropertyDetailsResponse,
  PropertySearchResponse,
  RentSourcePropertyInsert,
  SimpleProperty
} from 'common'

export const useRentsourceStore = defineStore('rentsource', {
  state: () => ({
    propertySearchCancelable: null as CancelablePromiseWrapper<PropertySearchResponse[]> | null
  }),
  actions: {
    propertySearch(
      q: string,
      lat?: number,
      lon?: number,
      zipCode?: string,
      state?: string,
      maxDistance?: number
    ) {
      if (this.propertySearchCancelable) {
        this.propertySearchCancelable.cancel()
        this.propertySearchCancelable = null
      }

      const promise = rentsourceApi
        .propertySearch(q, lat, lon, zipCode, state, maxDistance)
        .then((results) => {
          this.propertySearchCancelable = null
          return results
        })

      this.propertySearchCancelable = promise
      return promise.unwrap()
    },
    async marketSearch(data: MarketFilters) {
      return rentsourceApi.marketSearch(data)
    },
    async details(id: string) {
      return rentsourceApi.details(id)
    },
    async insertProperty(data: RentSourcePropertyInsert) {
      return rentsourceApi.insertProperty(data)
    },
    async comparables(
      subject: PropertyDetailsResponse | SimpleProperty,
      params: {
        excludedIds: string[]
        selectedIds: string[]
        topN: number
        renovations?: number
        maxDistance?: number
        minNumberUnits?: number
        maxNumberUnits?: number
        minYearBuilt?: number
        maxYearBuilt?: number
        minNumberStories?: number
        maxNumberStories?: number
        useEmbedding?: boolean
        isAffordable?: boolean
        isSenior?: boolean
        isStudent?: boolean
      }
    ) {
      return rentsourceApi.comparables(subject, params)
    },
    async marketComparables(filters: MarketComparablePayload) {
      return rentsourceApi.marketComparables(filters)
    },
    async marketStatistics(subject: MarketStatsQuery) {
      return rentsourceApi.marketStatistics(subject)
    },
    async marketShapeSearch(q: string) {
      return rentsourceApi.marketShapeSearch(q)
    }
  }
})
